module.exports = __webpack_public_path__ + "static/receiptOfPayment-7fc3cf9d43303fb665f4d451d8f291c1.svg";